import { render, staticRenderFns } from "./UserPictureView.vue?vue&type=template&id=6d66c06f&scoped=true"
import script from "./UserPictureView.vue?vue&type=script&lang=js"
export * from "./UserPictureView.vue?vue&type=script&lang=js"
import style0 from "./UserPictureView.vue?vue&type=style&index=0&id=6d66c06f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d66c06f",
  null
  
)

export default component.exports